// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/css/table.css);"]);
// Module
exports.push([module.id, "\nlabel[data-v-4f862064] {\n    margin: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
